import { useEffect, useMemo, useState } from "react";
import branches from "./branchesData";
import "../../styles/Branches.css";

function RegionIcon() {
  return (
    <svg className="branch-tab-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M3.4 9h17.2M3.4 15h17.2M12 3c2.1 2.3 3.2 5.3 3.2 9S14.1 18.7 12 21M12 3C9.9 5.3 8.8 8.3 8.8 12S9.9 18.7 12 21"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg className="branch-tab-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle
        cx="12"
        cy="10"
        r="2.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  );
}
function GateIcon() {
  return (
    <svg
      className="branch-gate-icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M6 21V8.5C6 5.5 8.4 3 12 3s6 2.5 6 5.5V21"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />

      <path
        d="M9 21V9.5h6V21"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />

      <path
        d="M4 21h16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />

      <circle cx="13.2" cy="15" r="0.8" fill="currentColor" />
    </svg>
  );
}
export default function Branches() {
  const [activeRegionSlug, setActiveRegionSlug] = useState(
    branches[0]?.slug || ""
  );

  const activeRegion = useMemo(
    () =>
      branches.find((region) => region.slug === activeRegionSlug) ||
      branches[0],
    [activeRegionSlug]
  );

  const [activeCitySlug, setActiveCitySlug] = useState(
    activeRegion?.cities?.[0]?.slug || ""
  );

  useEffect(() => {
    if (!activeRegion?.cities?.some((city) => city.slug === activeCitySlug)) {
      setActiveCitySlug(activeRegion?.cities?.[0]?.slug || "");
    }
  }, [activeRegion, activeCitySlug]);

  useEffect(() => {
    document.title = "فروع زايروس";
  }, []);

  const activeCity = useMemo(
    () =>
      activeRegion?.cities?.find((city) => city.slug === activeCitySlug) ||
      activeRegion?.cities?.[0],
    [activeRegion, activeCitySlug]
  );

  const changeRegion = (region) => {
    setActiveRegionSlug(region.slug);
    setActiveCitySlug(region.cities?.[0]?.slug || "");
  };

  if (!activeRegion || !activeCity) return null;

  const activeBranchName = `${activeCity.city.ar} - ${activeCity.mall.ar}`;

  return (
    <main className="branches-page">
      <section className="s-block s-block--store-branches s-block--store-branches--buttons">
        <div className="branches-page__inner">
          <div className="home-block-title">
            <p className="branches-page__title">
              - فروع زايروس حول المملكة -
            </p>
            <span className="enhanced-title-border home-block-line" />
          </div>

          <div className="store-branches-multiple-countries">
            <div className="country-tabs-container">
              <div className="btn-tabs-container">
                {branches.map((region) => (
                  <button
                    key={region.slug}
                    type="button"
                    className={`btn-tab-primary country-tab ${
                      region.slug === activeRegion.slug ? "active" : ""
                    }`}
                    onClick={() => changeRegion(region)}
                  >
                    <RegionIcon />
                    <span>{region.name.ar}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="country-content active">
              <div className="branches-layout">
                <aside className="branches-sidebar">
                  <div className="btn-tabs-vertical">
                    {activeRegion.cities.map((city) => (
                      <button
                        key={city.slug}
                        type="button"
                        className={`btn-tab-secondary city-tab-vertical ${
                          city.slug === activeCity.slug ? "active" : ""
                        }`}
                        onClick={() => setActiveCitySlug(city.slug)}
                      >
                        <LocationIcon />
                        <span>
                          {city.city.ar} - {city.mall.ar}
                        </span>
                      </button>
                    ))}
                  </div>
                </aside>

                <div className="branches-map-wrapper">
                  {activeCity.gate && (
                      <div className="branch-gate-row">
                        <span className="branch-gate-icon-wrapper">
                          <GateIcon />
                        </span>

                        <span className="branch-gate-text">
                          {activeCity.gate.ar}
                        </span>
                      </div>
                    )}
                  <div id="branch-map">
                    <iframe
                      key={activeCity.slug}
                      className="s-block--store-branches__map-element"
                      title={activeBranchName}
                      src={activeCity.map.embed}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}